import angular from 'angular';
import productsListComponent from './products-list.component';
import PriceFilterModule from './price-filter/price-filter';
import DynamicFiltersModule from './dynamic-filters/dynamic-filters';
import ModalAtributosValores from './modal-atributos-valores/modal-atributos-valores.controller';
import ModalAtributos from './modal-atributos/modal-atributos.controller';
import ProductsPageToolboxModule from './products-page-toolbox/products-page-toolbox';

let productsListModule = angular.module('productsList',[
  PriceFilterModule.name,
  DynamicFiltersModule.name,
  ProductsPageToolboxModule.name,
])
  .controller('modalAtributosValores', ModalAtributosValores)
  .controller('modalAtributos', ModalAtributos)
  .component('productsList', productsListComponent);

export default productsListModule;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/products-list/products-list.js
 **/